import { render, staticRenderFns } from "./ExtraFieldTab.vue?vue&type=template&id=df5dea2a"
import script from "./ExtraFieldTab.vue?vue&type=script&lang=ts"
export * from "./ExtraFieldTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df5dea2a')) {
      api.createRecord('df5dea2a', component.options)
    } else {
      api.reload('df5dea2a', component.options)
    }
    module.hot.accept("./ExtraFieldTab.vue?vue&type=template&id=df5dea2a", function () {
      api.rerender('df5dea2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ExtraFieldTab.vue"
export default component.exports